import richText from "utilities/richText"

export default function FAQ({ blok }) {
  return (
    <div className="pb-3 last:pb-0">
      {blok?.question ? <h3 className="text-m2 font-semibold pb-3">{blok?.question}</h3> : null}
      {richText(blok?.answer)}
    </div>
  )
}
